<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="disciplina-reprovacao-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>

                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="pelotaoReprovacao" class="form-label">Pelotao</label>
                                <input
                                    id="pelotaoReprovacao"
                                    v-model="pelotao"
                                    @keyup="apertouEnter"
                                    type="text"
                                    class="form-control form-control-solid"
                                    placeholder="Pelotao"
                                />
                            </div>

                            <div class="col-12 col-md-6 col-lg-9 panel-actions">
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar filtros
                                </button>
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false">
                            <th>Aluno</th>
                            <th>Pelotão</th>
                            <th>Média</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import { namespace } from 'vuex-class';
    import CardRh from "@/components/cards/ManzaCard.vue";
    import MatriculaService from "@/service/v1/sigap/MatriculaService";
    import SiteUtils from '@/assets/ts/aplicacao/site';
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import { Prop } from 'vue-property-decorator';

    const authStore = namespace('auth');

    @Options({
        name: "ReprovacaoDisciplinaIndex",
        components: { CardRh, KDataTable },
    })
    export default class ReprovacaoDisciplinaIndex extends Vue {
        @Prop() readonly disciplina!: any;

        @authStore.Getter
        public perfis!: any;

        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public matriculaId: any = null;
        public disciplinaId: any = null;
        public turmaId: any = null;
        public pelotao = '';

        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
        }

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.refreshTable();
            }
        }

        public limparFiltros() {
            this.pelotao = '';
            this.refreshTable();
        }

        created() {
            this.disciplinaId = this.$route.params.id;
            this.turmaId = this.disciplina.turmaId;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.service = new MatriculaService();
            this.config.ajax = {
                url: this.service.getApiUrl() + '/Dependencia',
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        disciplinaId: this.disciplinaId,
                        turmaId: this.turmaId,
                        pelotao: this.pelotao,
                        search: d.search.value,
                    };
                    return dados;
                }
            };
            this.config.columns = [
                { data: 'usuario.nome', name: 'usuario', orderable: false },
                { data: 'pelotao', name: 'pelotao', class: 'text-center', orderable: false },
                { data: 'mediaFinal', name: 'mediafinal', orderable: false },
            ];
        }
    }
</script>

<style scoped>
    .disciplina-reprovacao-page {
        display: grid;
        gap: 24px;
    }

    .filter-panel,
    .table-panel {
        border: 1px solid #e5edf6;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
        padding: 15px;
    }

    .filter-panel {
        position: relative;
        padding-top: 24px;
    }

    .panel-border-label {
        position: absolute;
        top: -9px;
        left: 18px;
        padding: 0 10px;
        background: #ffffff;
        color: #102542;
        font-size: 0.95rem;
        font-weight: 800;
        line-height: 1.4;
    }

    .table-panel {
        padding: 2px 10px !important;
    }

    .panel-actions {
        text-align: end;
        margin-top: 20px;
    }

    .btn-sm {
        margin-left: 10px;
    }

    @media screen and (max-width: 991px) {
        .filter-panel,
        .table-panel {
            padding: 18px;
            border-radius: 18px;
        }

        .filter-panel {
            padding-top: 26px;
        }

        .panel-actions {
            text-align: left;
            margin-top: 0;
        }
    }
</style>
